import React from 'react'
import { FormInputSelectAndNavigateBranch } from '../../../../../../../ui/organisms'

const list = [
  {
    value: 'Private Residential',
    next: 'projectInfo.residentialProjectType',
  },
  {
    value: 'Private Commercial',
    next: 'projectInfo.commercialProjectType',
  },
  {
    value: 'State Construction',
    next: 'projectInfo.fedStateProjectType',
  },
  {
    value: 'Federal Construction',
    next: 'projectInfo.fedStateProjectType',
  },
]

export default {
  title: 'What type of construction project are you purchasing materials for?',
  list,
  component: (props) => <FormInputSelectAndNavigateBranch list={list} {...props}/>,
}
